/**
 * ShopPanel subscription IDs shared by API, panel, admin and UI.
 * B65 (2026-10-06): handwritten ID lists drifted across fifteen sites.
 * MO1 (2026-10-09): prices and limits now live alongside them in plans.ts;
 * storage quotas keep their existing source in storage-quota.ts.
 */
export const PLAN_IDS = ['starter', 'pro', 'enterprise'] as const

export type PlanId = (typeof PLAN_IDS)[number]

export function isPlanId(wert: unknown): wert is PlanId {
  return (PLAN_IDS as readonly unknown[]).includes(wert)
}
